<template>
  <LegalPage
    title="Contact Us"
    intro="For questions or feedback about the content on this site, you can reach us at the address below."
    :sections="sections"
    email="contact@gbwhatsdroid.com"
    page-name="contact"
  />
</template>

<script>
import LegalPage from '@/components/LegalPage.vue';

export default {
  name: 'Contact',
  components: {
    LegalPage,
  },
  data() {
    return {
      sections: [
        {
          heading: 'Email',
          paragraphs: [
            'Contact address: contact@gbwhatsdroid.com',
            'Please include the topic of your message so we can route it correctly. We read inquiries but cannot guarantee a reply to every message.',
          ],
        },
        {
          heading: 'What to Include',
          items: [
            'The page or topic your question relates to.',
            'The Android version or device model if your question involves installation.',
            'A short description of the issue without sharing private account details.',
          ],
        },
      ],
    };
  },
};
</script>
